import React from "react";
import FoodCard from "./common/FoodCard";
import SearchCategories from "./SearchCategories";
import SearchFilterBtn from "./SearchFilterBtn";
import SearchHeader from "./SearchHeader";
import SortedData from "../data/data.json";

const ZA = () => {
  return (
    <div>
      <SearchHeader />
      <SearchFilterBtn />
      <SearchCategories />
      <FoodCard
        data={SortedData.sort((a, b) => b.itemName.localeCompare(a.itemName))}
      />
    </div>
  );
};

export default ZA;
